module.exports = __webpack_public_path__ + "media/images/p-about/can/donation-a04c22b5d7f508217454ca0e6b57bef4.svg";